import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";

export const StyledInfoCollaboratorContainer = styled.div<{
  $disabled?: boolean;
}>`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  border-radius: 8px;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  flex: 1;
`;

export const StyledSingleCollaboratorContainer = styled(
  StyledInfoCollaboratorContainer,
)<{
  $isSelectedCollaborator?: boolean;
}>`
  justify-content: space-between;
  padding: 8px;

  background-color: ${({ $isSelectedCollaborator }) =>
    $isSelectedCollaborator ? theme.colors.purple_2 : "transparent"};

  &:hover {
    background-color: ${theme.colors.purple_2};
  }
`;

export const StyledAccordionWrapper = styled(StyledInfoCollaboratorContainer)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;

  & > div {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }
`;

export const StyledCollaboratorContainer = styled.div<{
  $isEvaluationOpen: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  margin-top: 20px;
  gap: 20px;

  & .empty-state-container {
    flex: 1;
    overflow-y: auto;
  }
`;

export const StyledCollaboratorSelectContainer = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export const StyledCollaboratorExaminedContainer = styled(
  StyledCollaboratorSelectContainer,
)`
  gap: 35px;
  display: flex;
  flex-direction: column;
`;

export const StyledTitleInternalGrade = styled.div`
  width: 100%;
  justify-content: space-between;
  display: flex;
`;

export const StyledCollaboratorExaminedList = styled.div<{
  $isEvaluationOpen: boolean;
}>`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
`;
